/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Builders_DescriptionInputs */

const en_directory_hubs_builders_description = /** @type {(inputs: Directory_Hubs_Builders_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet the people shipping products that humans and AI can discover.`)
};

const zh_directory_hubs_builders_description = /** @type {(inputs: Directory_Hubs_Builders_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认识那些正在发布产品、让人类和 AI 都能发现它们的创作者。`)
};

/**
* | output |
* | --- |
* | "Meet the people shipping products that humans and AI can discover." |
*
* @param {Directory_Hubs_Builders_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_builders_description = /** @type {((inputs?: Directory_Hubs_Builders_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Builders_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_builders_description(inputs)
	return zh_directory_hubs_builders_description(inputs)
});
export { directory_hubs_builders_description as "directory.hubs.builders.description" }